export default __webpack_public_path__ + "268f8978bba9ae4c62babe3dcdee562b.png";